// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-app-bar[data-v-7a4e0324]{background-size:cover}.header[data-v-7a4e0324]{font-size:1.1rem;line-height:1.5;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:400}.footer[data-v-7a4e0324]{background-color:#f4f4f4}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
